/**
 * name 热度日历
 * author zhang.yingyu
 * createTime 2019-04-08
 */
angular.module('hotCalendarModule', [])
    .directive('hotCalendar', ['$q', '$timeout',"$filter", function ($q, $timeout,$filter) {
        return {
            restrict: 'AE',
            replace: true,
            templateUrl: "./planningCenter/mediaLaboratory/directive/hotCalendar/main_tpl.html",
            scope: {
                choiceDate: "=",
                choiceWeekDay: "=",
                callback:"&",
                hotMap:"="
            },
            link: function ($scope, iElement, iAttrs) {
                $timeout(function(){
                    initStatus();
                    initData();
                    function initStatus(){
                        var dataInit=new Date();
                        var month=dataInit.getMonth()+1;
                        $scope.status={
                            isShowHotCalMore:false,
                        };
                        $scope.data={
                            year:dataInit.getFullYear(), //年
                            month:month<10?'0'+month:month, //月
                            choiceDay:dataInit.getDate(),//日
                            choiceMonth:"",
                            choiceYear:"",
                            monthDays:0, //当前月的天数
                            hotCalendarList:[],//日历列表
                            weekData:["日","一","二","三","四","五","六"],
                            changeStep:0,
                            hotMapColorArr:[],
                        };
                    };
                    function initData(){
                        $scope.data.width=($(".calendar-cont-date-an").width()-60)/26;
                        $scope.hotMap=getHotMapColorData($scope.hotMap);
                        if($scope.hotMap){
                            var hotMapInitDate=$scope.hotMap[0].time.split("-");
                            $scope.data.year= hotMapInitDate[0];
                            $scope.data.month= hotMapInitDate[1];
                            $scope.data.choiceDay= hotMapInitDate[2];
                        }
                        $scope.data.choiceMonth = $scope.data.month;
                        $scope.data.choiceYear = $scope.data.year;
                        $scope.data.monthDays = getMonthDay($scope.data.year,$scope.data.month,0);
                        $scope.data.hotCalendarList = getCalendar($scope.data.year,$scope.data.month,'open');
                        $scope.data.hotCalendarListAn = getCalendar($scope.data.year,$scope.data.month,'pack');
                        $scope.choiceDate=$scope.data.choiceYear+"-"+$scope.data.choiceMonth+"-"+$scope.data.choiceDay;
                        $scope.choiceWeekDay="星期"+$scope.data.weekData[new Date($scope.data.year.toString()+'/'+$scope.data.month+'/'+$scope.data.choiceDay).getDay()];
                        $timeout(function(){
                            $(".calendar-cont-date-an").find("ul li.active").click();
                        },300);
                    };
                    /**
                     * [getHotMapColorData description] 获取热度颜色值
                     * @param type
                     */
                    function getHotMapColorData(data){
                        if(data.length>0){
                            var initArr=[];
                            var max = angular.copy(data).sort(function(a,b){
                                return a.value-b.value;
                            });
                            var maxData=max[max.length-1].value;
                            var ps=(maxData)/8;
                            for(var i=1;i<=8;i++){
                                initArr.push(i*ps);
                            }
                            for(var j=0;j<data.length;j++){
                                for(var i=0;i<initArr.length;i++){
                                    if(!initArr[i-1]){
                                        initArr[i-1]=1;
                                    }
                                    if(initArr[i-1]<=data[j].value&&data[j].value<=initArr[i]){
                                        data[j].hotColor=i;
                                    }
                                }
                            };
                            return data;
                        }
                    };
                    /**
                     * [changeMonth description] 切换月
                     * @param type
                     */
                    $scope.changeMonth=function(type){
                        $scope.data.changeStep=0;
                        $(".hot-calendar").find(".hot-calendar-u").css({marginLeft: 30+'px'});
                        if(type==="prev"){
                            $scope.data.month--;
                            if ($scope.data.month === 0) {
                                $scope.data.month = 12;
                                $scope.data.year--;
                            }
                        }else if(type==="next"){
                            $scope.data.month++;
                            if($scope.data.month===13){
                                $scope.data.month=1;
                                $scope.data.year++;
                            };
                        }
                        $scope.data.hotCalendarList=getCalendar($scope.data.year,$scope.data.month,'open');
                        $scope.data.hotCalendarListAn=getCalendar($scope.data.year,$scope.data.month,'pack');
                        $scope.data.month = $scope.data.month < 10 ? '0' + $scope.data.month : $scope.data.month;
                    };
                    /**
                     * [changeCaneldarPo description] 改变日历位置
                     * @param type
                     */
                    $scope.changeCaneldarPo=function(type){
                        var distance=$scope.data.width,multiple=1,leftDistance,fixedGrid=26;
                        if(type === "left"){
                            if($scope.data.changeStep === $scope.data.monthDays-fixedGrid) return;
                            $scope.data.changeStep++;
                            leftDistance=-distance*multiple*$scope.data.changeStep+30;
                        }else if(type === 'right'){
                            if($scope.data.changeStep === 0) return;
                            $scope.data.changeStep--;
                            leftDistance=-distance*multiple*$scope.data.changeStep+30;
                        }
                        $(".hot-calendar").find(".hot-calendar-u").animate({marginLeft: leftDistance+'px'}, {duration: 300, easing: "swing"});
                    };
                    /**
                     * [hotCalendarShowM description] 两种日历切换
                     * @param type
                     */
                    $scope.hotCalendarShowM=function(){
                        $scope.$emit("getTrsHeight");
                        $scope.status.isShowHotCalMore=!$scope.status.isShowHotCalMore;
                    };
                    /**
                     * [getInitCalendarData description] 获取日历时间
                     * @param item
                     */
                    $scope.getInitCalendarData=function(item){
                        var dayInit=item.days<10?'0'+item.days:item.days;
                        if(item.days===""||item.hotColor<0)return;
                        $scope.data.choiceDay=dayInit;
                        $scope.data.choiceMonth=$scope.data.month;
                        $scope.data.choiceYear=$scope.data.year;
                        $scope.choiceWeekDay="星期"+$scope.data.weekData[new Date($scope.data.year.toString()+'/'+$scope.data.month+'/'+$scope.data.choiceDay).getDay()];
                        $scope.choiceDate=$scope.data.choiceYear+"-"+$scope.data.choiceMonth+"-"+dayInit;
                        $scope.$emit('getChoiceDate', {tranDatas: $scope.choiceDate});
                        $scope.callback();

                    };
                    function getMonthDay(year,month){
                        var d=new Date(year,month,0);
                        return d.getDate();
                    }
                    function getWeekDay(year,month){
                        var time=[year,month,'01'].join(",");
                        var weekDay=new Date(time).getDay();
                        return weekDay;
                    };
                    function initCalendarData(value,arr){
                        var months=parseInt($scope.data.month);
                        var monthD=months<10?'0'+months:months;
                        for(var i=0;i<value;i++){
                            var dayD=(i+1<10?'0'+(i+1):(i+1));
                            var initTime=$scope.data.year+'-'+monthD+'-'+dayD;
                            var obj={
                                time:initTime,
                                days:i+1,
                                hotColor:-5
                            };
                            if($scope.hotMap){
                                for(var j=0;j<$scope.hotMap.length;j++){
                                    if(initTime==$scope.hotMap[j].time){
                                        obj.hotColor=$scope.hotMap[j].hotColor;
                                    }
                                }
                            }
                            arr.push(obj);
                        }
                        return arr;
                    };
                    function getCalendar(year,month,type){
                        var initArr=[];
                        var blankDate={
                            time:"",
                            days:"",
                            hotColor:-5
                        };
                        var initData={
                            days:"",
                            weekDay:"",
                            prevBlank:"",
                            nextBlank:"",
                        };
                        initData.days=getMonthDay(year,month);
                        $scope.data.monthDays=initData.days;
                        initData.weekDay=getWeekDay(year,month);
                        initData.prevBlank=initData.weekDay;
                        initData.nextBlank=(initData.days+initData.weekDay)%7==0?0:7-(initData.days+initData.weekDay)%7;
                        if(type==="open"){
                            for(var i=0;i<initData.prevBlank;i++){
                                initArr.push(blankDate);
                            }
                        }
                        initCalendarData(initData.days,initArr);
                        if(type==="open"){
                            for(var i=0;i<initData.nextBlank;i++){
                                initArr.push(blankDate);
                            }
                        }
                        return initArr;
                    };
                    /**
                     * 缩放窗口
                     */
                    function resizeCalendarCont(){
                        window.addEventListener("resize", function(){
                            $scope.data.width=($(".calendar-cont-date-an").width()-60)/26;
                        });
                    };
                    resizeCalendarCont();
                },500);
            }
        };
    }]);